import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import './i18n'; 
import "./App.css";
import ScrollToTop from "./components/ScrollToTop.jsx";
import Header from "./components/Header/Header.js";
import Footer from "./components/Footer/Footer.jsx";
import Home from "./components/Home/Home.js";
import FAQ from "./components/FAQ/FAQ.js";
import MasajesTerapeuticos from "./components/MasajesTerapeuticos/MasajesTerapeuticos.js";
import SobreMi from "./components/SobreMi/Main.jsx";
import TerapiasHolisticas from "./components/TerapiasHolisticas/TerapiasHolisticas.js";
import VistaDetallada from "./components/VistaDetallada/VistaDetallada.jsx";

import HeaderMoviles from "./components/Header/HeaderMoviles.js";
import { MonedaProvider } from "./context/MonedaContext.js";

export const lenis = new Lenis({
  smooth: true,
  lerp: 0.1, // suavidad (0 a 1)
  direction: "vertical",
  gestureDirection: "vertical",
  smoothTouch: true,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

const App = () => {
  // Biblioteca de desplazamiento suave

  return (
    <div className="App">

    {/* envuelto todos los componentes en monedaProvider */}
      <MonedaProvider>
      <Router>
        <Header />
        <HeaderMoviles />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQ />} />
          <Route
            path="/masajesAyurvedicos"
            element={<MasajesTerapeuticos />}
          />
          <Route path="/sobreMi" element={<SobreMi />} />
          <Route path="/terapiasHolisticas" element={<TerapiasHolisticas />} />
          <Route path="/vistaDetallada/:id" element={<VistaDetallada />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>

        <Footer />
      </Router>
      <a
        href="https://wa.me/5492901508935?text=Hola%2C%20quiero%20más%20información"
        className="whatsapp-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/img/BotonGatoWsp.webp" alt="Botón de Whatsapp" />
      </a>
      </MonedaProvider>
    </div>
  );
};

export default App;
